import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SessionService } from './session.service';

export const sessionGuard: CanActivateFn = () => {
  const router = inject(Router);
  const sessionService = inject(SessionService);
  const token = localStorage.getItem('token');

  if (!token) {
    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }

  const jwtHelper = new JwtHelperService();

  if (jwtHelper.isTokenExpired(token)) {
    sessionService.clearAll();
    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }

  return true;
};
